import React from 'react'
import {
  Card, CardHeader, CardContent,
  Typography,
} from '@material-ui/core'

export default class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showDetail: true,
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({showDetail:true, error, errorInfo})
  }

  render() {
    const {children} = this.props
    const {showDetail, error, errorInfo} = this.state

    if (errorInfo) {
      // Error path

      return (
        <Card
          style={{ background: 'rgb(255, 241, 214)', 'marginBottom': '15px' }}
          onClick={() => this.setState({ showDetail: !showDetail })}
        >
          <CardHeader title="😲 Oops! ⚠️ What happened...?" />
          <CardContent>
            <Typography style={{ whiteSpace: 'pre-wrap' }}>
              {showDetail === true &&
                <>
                  {error && error.toString()}
                  <br />
                  {errorInfo.componentStack}
                </>
              }
            </Typography>
          </CardContent>
        </Card>
      );
      // return (
      //   <div>
      //     <h2>Something went wrong.</h2>
      //     <details style={{ whiteSpace: 'pre-wrap' }}>
      //       {error && error.toString()}
      //       <br />
      //       {errorInfo.componentStack}
      //     </details>
      //   </div>
      // );
    }
    // Normally, just render children
    return children;
  }
}
